import Vue from "vue";
import Vuex from "vuex";
import common from "./storeModule/common/store";
import adminMessage from "./storeModule/adminMessage/store";
import editUserIdentifier from "./storeModule/editUserIdentifier/store";
import inviteAdministrator from "./storeModule/inviteAdministrator/store";
import editAdministratorName from "./storeModule/editAdministratorName/store";
import deleteAdministrator from "./storeModule/deleteAdministrator/store";
import volumeLicenseUsers from "./storeModule/volumeLicenseUsers/store";
import returnLicense from "./storeModule/returnLicense/store";
import useStartingUrl from "./storeModule/useStartingUrl/store";
import deleteAdministratorInvitationUrl from "./storeModule/deleteAdministratorInvitationUrl/store";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export interface RootState {}

export default new Vuex.Store<RootState>({
  modules: {
    common,
    adminMessage,
    editUserIdentifier,
    inviteAdministrator,
    editAdministratorName,
    deleteAdministrator,
    volumeLicenseUsers,
    returnLicense,
    useStartingUrl,
    deleteAdministratorInvitationUrl,
  },
  strict: debug,
});
